<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { Permission } from "../../../../../types/auth";
import InventoryForm from "./InventoryForm.vue";
import { FilterField, TableField } from "../../../../../components/table/table";
import ListTemplate from "../../../../../components/ui/common/ListTemplate.vue";

const props = defineProps<{
  data?: any | [];
  unit_of_measures?: any | [];
  permissions?: Permission[];
  item?: any | null;
  packingInventoryFields: TableField[];
  packingInventoryData: any
}>();

const endPoint = "/clients/inventory/item-management/items/price-";
const title = "Inventory";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);

const rows = ref<any[]>(props.data);

const fields: TableField[] = [
  {
    name: "warehouse",
    caption: "Warehouse",
    sortable: true,
    fieldType: "text",
  },
  { name: "on_hand", caption: "On Hand", sortable: false, fieldType: "number" },
  { name: "cost", caption: "Cost", sortable: false, fieldType: "currency" },
  {
    name: "reorder_level",
    caption: "Reorder Level",
    sortable: false,
    fieldType: "number",
  },
  {
    name: "reorder_uom",
    caption: "Re Order UOM",
    sortable: false,
    fieldType: "text",
  },
  {
    name: "reorder_quantity",
    caption: "Reorder Quantity",
    sortable: false,
    fieldType: "number",
  },
  { name: "minimum", caption: "Minimum", sortable: false, fieldType: "number" },
  { name: "maximum", caption: "Maximum", sortable: false, fieldType: "number" },
  { name: "active", caption: "active", sortable: false, fieldType: "status" },
];

const shelfFields: TableField[] = [
  { name: "shelf", caption: "Shelf", sortable: true, fieldType: "text" },
  {
    name: "on_hand",
    caption: "On Hand",
    sortable: false,
    fieldType: "number",
    width: "150px",
  },
];

const filterFields: FilterField[] = [
  {
    name: "active",
    label: "Status",
    type: "select",
    value: "",
    options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
];

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data: any) => {
  selectedData.value = data;
};

const handleSave = (data: any) => {
  rows.value = data;
};

onMounted(() => {
  rows.value = props.data;
});

watch(
  () => props.data,
  () => {
    rows.value = props.data;
  },
  { immediate: true }
);
</script>

<template>
  <ListTemplate
    :endPoint="endPoint"
    :title="title"
    :fields="fields"
    :actions="[]"
    :filterFields="filterFields"
    :tabList="[]"
    :refreshData="refreshData"
    @mode="changeMode"
    @show="showForm = true"
    :showForm="showForm"
    @data="handleData"
    :data="rows"
    :remote="false"
    :showHeader="false"
    :showQuickTour="false"
    :showQuickView="false"
    :showPagination="false"
    :allowDisable="false"
    :allow-edit="false"
    :show-child-row="true"
    :child-row-fields="shelfFields"
    child-row-title="Shelf Inventory"
    child-row-table-width="500"
    child-row-data-field="shelfs"
    :ignore-max-height="true"
  >
    <template #header-actions> </template>
    <template #content>
      <ListTemplate
    :endPoint="endPoint"
    class="mt-4"
    v-if="packingInventoryFields.length > 0 && packingInventoryData.length > 0"
    title="Packing Inventory"
    :fields="packingInventoryFields"
    :actions="[]"
    :filterFields="[]"
    :tabList="[]"
    :data="packingInventoryData"
    :refreshData="false"
    :show-form="false"
    :remote="false"
    :showHeader="false"
    :showQuickTour="false"
    :showQuickView="false"
    :showPagination="false"
    :allowDisable="false"
    :allow-edit="false"
    :ignore-max-height="true"
  >
      </ListTemplate>
      </template>
    <template #form-view>
      

      <InventoryForm
        :permissions="permissions"
        v-if="showForm"
        :data="selectedData"
        :item="item"
        :end-point="endPoint"
        :title="title"
        :mode="formMode"
        @save="handleSave"
        @close="showForm = !showForm"
      />
    </template>
  </ListTemplate>
</template>
